import { render, staticRenderFns } from "./MPriceMachine.vue?vue&type=template&id=3910694a&"
import script from "./MPriceMachine.vue?vue&type=script&lang=ts&"
export * from "./MPriceMachine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports